import { render, staticRenderFns } from "./RichestPerson.vue?vue&type=template&id=656c3088&lang=pug&"
import script from "./RichestPerson.vue?vue&type=script&lang=js&"
export * from "./RichestPerson.vue?vue&type=script&lang=js&"
import style0 from "./RichestPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports